import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/common/Loader';

const AdminPanelRoute = ({ children }) => {
  const { isAuthenticated, loading, userType } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader fullScreen />;
  }

  if (!isAuthenticated || userType !== 'admin') {
    return <Navigate to="/admin-panel/login" state={{ from: location }} replace />;
  }

  return children || <Outlet />;
};

export default AdminPanelRoute;
